import React from "react";
import { useNavigate } from "react-router-dom";

export const CardColorSwatches = ({ slug, colors, max = 7 }) => {
  const navigate = useNavigate();
  if (!colors?.length) return null;
  return (
    <div
      className="flex items-center gap-2 mt-3 flex-wrap"
      data-testid={`card-swatches-${slug}`}
    >
      {colors.slice(0, max).map((c) => (
        <button
          key={c.name}
          type="button"
          title={c.name}
          aria-label={`View in ${c.name}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            navigate(`/product/${slug}?color=${encodeURIComponent(c.name)}`);
          }}
          className="w-5 h-5 rounded-full border border-white/25 hover:border-white hover:scale-125 transition-transform"
          style={{ background: c.hex }}
          data-testid={`card-swatch-${slug}-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
        />
      ))}
    </div>
  );
};
